/* eslint-disable no-return-await */
import moment from 'moment'
import React, { useContext, useLayoutEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import clsx from 'clsx'

import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress
} from '@material-ui/core'
import { EventAvailable } from '@material-ui/icons'
import deburr from 'lodash.deburr'
import ButtonGZ from '../../components/Button'
import useStyles from './styles'

import Context from '../../context'
import { addOrEditNews, getNewsList } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

import NewsListItem from './NewsListItem'

function NewsList() {
  const classes = useStyles()
  const { user, setUser, aboutCurrentPage, setAboutCurrentPage } = useContext(Context)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState([])
  const [sortBy, setSortBy] = useState('0')
  const [query, setQuery] = useState('')
  const [checked, setChecked] = useState([])
  const [deleteModalData, setDeleteModalData] = useState(null)
  const [showPostModal, setShowPostModal] = useState(null)

  const listUpdate = async () => {
    setLoading(true)
    return await getNewsList()
  }

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      history.replace('/')
      return
    }
    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: 'Fique Ligado',
      buttons: [{ title: 'Novo Post', pathname: '/newsform' }]
    })
    // getData();
    listUpdate().then(data => {
      setData(data)
      setLoading(false)
    })
  }, [])

  async function getData() {
    try {
      setLoading(true)
      listUpdate().then(data => setData(data))
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  let erroMessage = ''
  let finalData = []

  finalData = (() => {
    try {
      let finalData = data
      // Filtro perfil do usuário não visualizar postagem de outros clientes
      if (user != null) {
        if (user.userGroup === 6) {
          finalData = finalData.filter(item => {
            return (
              item.WhiteLabelNewsWhiteLabelLists?.filter(i => {
                return i.whiteLabelId === user.whiteLabelId
              }).length > 0
            )
          })
        }
      }

      if (sortBy === '1')
        finalData = finalData.sort((one, another) => one.title.localeCompare(another.title))
      if (sortBy === '2')
        finalData = finalData.sort(
          (one, another) => new Date(one.createdAt) - new Date(another.createdAt)
        )
      return finalData.filter(item => new RegExp(deburr(query), 'i').test(deburr(item.title)))
    } catch (err) {
      erroMessage = React.createElement(
        'div',
        { className: 'container' },
        <ButtonGZ color="primary" onClick={() => history.go(0)}>
          Atualize a página!
        </ButtonGZ>
      )

      console.error(err)
    }
  })()

  function handleSortByChange(e) {
    setSortBy(e.target.value)
  }

  function handleQueryChange(e) {
    setQuery(e.target.value)
  }

  function setToShowPostModal(item) {
    setShowPostModal(item)
  }
  function hidePostModal() {
    setShowPostModal(null)
  }

  function setToBeDeleted(item) {
    return function () {
      let whiteLabelList = item?.WhiteLabelNewsWhiteLabelLists || []
      let whiteLabelListAssociated = whiteLabelList.map(list => {
        return {
          whiteLabelId: list.whiteLabelId,
          whiteLabelNewsId: list.WhiteLabelNewsId,
          title: list.WhiteLabel.title
        }
      })
      setDeleteModalData({
        ...item,
        whiteLabelNewsWhiteLabelList: whiteLabelListAssociated
      })
    }
  }

  function setAllToBeDeleted() {
    // console.log('All checked: ', checked);
    const settedToBeDeleted = finalData
      .map(item => {
        return checked.includes(item.id) ? item : null
      })
      .filter(Boolean)

    const updatedToBeDeleted = settedToBeDeleted.map(selected => {
      let whiteLabelList = selected?.WhiteLabelNewsWhiteLabelLists || []
      let whiteLabelListAssociated = whiteLabelList.map(item => {
        return {
          whiteLabelId: item.whiteLabelId,
          whiteLabelNewsId: item.WhiteLabelNewsId,
          title: item.WhiteLabel.title
        }
      })
      return {
        ...selected,
        whiteLabelNewsWhiteLabelList: whiteLabelListAssociated
      }
    })

    console.log('All setted to be deleted: ', updatedToBeDeleted)
    setDeleteModalData(updatedToBeDeleted)
  }

  function hideDeleteModal() {
    setDeleteModalData(null)
  }

  function handleCheckUnit(name) {
    if (checked.includes(name)) {
      setChecked(checked => checked.filter(item => item !== name))
    } else {
      setChecked([...checked, name])
    }
  }

  function checkAll() {
    setChecked(finalData?.length !== checked?.length ? finalData?.map(({ id }) => id) : [])
  }

  async function deleteItem(item) {
    try {
      setDeleteModalData(null)
      setLoading(true)
      await addOrEditNews({
        ...item,
        situation: 2
      })
      await getData()
    } catch (err) {
      console.log(err)
    }
  }

  async function deleteAllItems(items) {
    try {
      setDeleteModalData(null)
      setLoading(true)
      const buildItemsObj = await items.map(item => {
        addOrEditNews({
          ...item,
          situation: 2
        })
      })
      await listUpdate().then(data => setData(data))
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
      setChecked([])
    }
  }

  return (
    <>
      {/* {console.log('Group 6', user)} */}
      {/* {console.log('All datas', data)} */}
      <div className={classes.outerContainer}>
        <div className={classes.content}>
          <div className={classes.row}>
            <div className={classes.filters}>
              <div className={classes.actions}>
                {checked.length > 0 ? (
                  <button
                    type="button"
                    className={classes.actionsBtn}
                    onClick={() => setAllToBeDeleted()}
                  >
                    Excluir
                  </button>
                ) : (
                  ''
                )}
              </div>
              <select className={classes.sorting} value={sortBy} onChange={handleSortByChange}>
                <option disabled value="0">
                  Ordenar por:
                </option>
                <option value="1">Título do Post</option>
                <option value="2">Data de publicação</option>
              </select>
            </div>
            <input
              className={classes.search}
              value={query}
              onChange={handleQueryChange}
              placeholder="Buscar..."
            />
          </div>
          <table className={classes.table}>
            <thead>
              <colgroup className={classes.hide}>
                <col />
                <col />
                <col />
                <col
                  className={clsx({
                    [classes.groupsColumn]: true,
                    [classes.hide]: user?.userGroup === 6
                  })}
                />
                <col />
              </colgroup>
              <tr>
                <th scope="col">
                  <Checkbox
                    className="checkbox-lines"
                    value="All"
                    onChange={checkAll}
                    className={classes.headerCheckbox}
                    checked={checked?.length === finalData?.length && finalData?.length > 0}
                  />
                </th>
                <th scope="col">Título</th>
                <th scope="col">Autor</th>
                <th
                  scope="col"
                  className={clsx({
                    [classes.hide]: user?.userGroup === 6
                  })}
                >
                  Grupo(s)
                </th>
                <th scope="col">Data de Publicação</th>
              </tr>
            </thead>
            <tbody>
              {finalData?.map(item => {
                return (
                  <NewsListItem
                    showGroups={user?.userGroup === 6}
                    handleCheckUnit={handleCheckUnit}
                    setShowPostModal={setShowPostModal}
                    setToBeDeleted={setToBeDeleted}
                    classes={classes}
                    item={item}
                    checked={checked}
                  />
                )
              })}
            </tbody>
          </table>
          {finalData?.length === 0 && erroMessage === '' && !loading ? (
            <div className="alert alert-info text-center m-4">
              Nenhum post encontrado. <Link to="/newsform">Crie o primeiro aqui.</Link>
            </div>
          ) : (
            ''
          )}
          {erroMessage}
          {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
        </div>
      </div>
      <Dialog
        open={!!deleteModalData}
        onClose={hideDeleteModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Excluir o Post</DialogTitle>
        {console.log(deleteModalData)}
        <DialogContent>
          <DialogContentText>
            {Array.isArray(deleteModalData)
              ? `Deseja realmente excluir os posts ${deleteModalData.map(
                  item => `${item.title} `
                )}?`
              : `Deseja realmente excluir o post ${deleteModalData?.title}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={hideDeleteModal}>
            Não
          </ButtonGZ>
          {Array.isArray(deleteModalData) ? (
            <ButtonGZ color="primary" onClick={() => deleteAllItems(deleteModalData)}>
              Sim
            </ButtonGZ>
          ) : (
            <ButtonGZ color="primary" onClick={() => deleteItem(deleteModalData)}>
              Sim
            </ButtonGZ>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!showPostModal}
        onClose={hidePostModal}
        transitionDuration={{ enter: 250, exit: 0 }}
        fullWidth
        maxWidth="sm"
      >
        {/* {console.log(showPostModal)} */}
        <DialogTitle>
          Post <strong> {showPostModal?.title}</strong>{' '}
        </DialogTitle>

        <DialogContent dividers>
          {!!showPostModal?.publishedDate &&
          moment().isBefore(moment(showPostModal?.publishedDate)) ? (
            <DialogContentText>
              <EventAvailable />
              {moment(showPostModal?.publishedDate).format('L [às] LT')}
            </DialogContentText>
          ) : (
            ''
          )}
          <img src={process.env.REACT_APP_IMAGES_URL + showPostModal?.image} width="100%" />

          <DialogContentText>
            <h4>{showPostModal?.legend}</h4>
          </DialogContentText>
          <DialogContentText>Autor: {showPostModal?.author}</DialogContentText>
          <DialogContentText>
            <div
              dangerouslySetInnerHTML={{
                __html: showPostModal?.content
              }}
            />
          </DialogContentText>
          <DialogContentText className={clsx({ [classes.hide]: user?.userGroup === 6 })}>
            Grupos:
            <strong>{`${showPostModal?.WhiteLabelNewsWhiteLabelLists.map(
              group => `${group.WhiteLabel.title} `
            )}`}</strong>
          </DialogContentText>
          <DialogContentText>{showPostModal?.calltoaction}</DialogContentText>
          <DialogContentText>
            <a href={showPostModal?.link}>{showPostModal?.link}</a>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGZ color="secondary" onClick={() => hidePostModal()}>
            Fechar
          </ButtonGZ>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default NewsList
